import React from 'react';
import { Icons } from '@ohif/ui-next';
import { DiagnosisState } from '../../utils';
import { ButtonContentProps } from './types';

const CONTENT: Record<DiagnosisState, { Icon: React.ElementType; label: string }> = {
  [DiagnosisState.IDLE]: { Icon: Icons.ToolMagnify, label: 'Diagnose' },
  [DiagnosisState.PROCESSING]: { Icon: Icons.ToolMagnify, label: 'Processing...' },
  [DiagnosisState.REQUIRES_ASSESSMENT]: {
    Icon: Icons.StatusSuccess,
    label: 'Requires Assessment',
  },
  [DiagnosisState.ASSESSED]: { Icon: Icons.StatusSuccess, label: 'Assessed' },
  [DiagnosisState.REVOCABLE]: { Icon: Icons.ToolReset, label: 'Revoke' },
};

export default function ButtonContent({ state }: ButtonContentProps) {
  const { Icon, label } = CONTENT[state];

  return (
    <>
      <Icon
        aria-hidden="true"
        className="h-5 w-5"
      />
      <span
        aria-live="polite"
        aria-atomic="true"
        className="align-middle"
      >
        {label}
      </span>
    </>
  );
}
